var baseUrl = "https://sara.europavard.se/";
// var baseUrl = "https://localhost/react/IHM/";
var docsUrl = baseUrl+"docs/";
var tsApi = baseUrl + "api/";

var cnfg = {
    api: tsApi,
    docsUrl :docsUrl,
    baseUrl: baseUrl,
}; 
export default cnfg;